import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import React from 'react';
import { makeStyles } from '@mui/styles';
import { NavLink } from 'react-router-dom';
import { Theme } from '@mui/material/styles';
import classNames from 'classnames';

interface IProps {
  path: string;
  primaryText: string;
  icon: React.ReactNode;
  nested?: boolean;
  disabled?: boolean;
  className?: string;
}

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  active: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: '50px',
    margin: '10px 0',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '& svg': {
      color: 'white',
    },
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export default function DrawerListItem(props: IProps) {
  const classes = useStyles();
  const { path, primaryText, icon, nested, disabled, className } = props;
  return (
    <ListItem
      button
      disabled={disabled}
      className={classNames(
        {
          [classes.nested]: nested,
        },
        className
      )}
      activeClassName={classes.active}
      component={NavLink}
      to={path}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={primaryText} />
    </ListItem>
  );
}
